import { render, staticRenderFns } from "./LogoHerzogDichtungen.vue?vue&type=template&id=806b7436&scoped=true"
import script from "./LogoHerzogDichtungen.vue?vue&type=script&lang=ts"
export * from "./LogoHerzogDichtungen.vue?vue&type=script&lang=ts"
import style0 from "./LogoHerzogDichtungen.vue?vue&type=style&index=0&id=806b7436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806b7436",
  null
  
)

export default component.exports